import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { authApi } from '../api';
import HrnbForm from '../components/controls/HrnbForm';
import HrnbFormControl from '../components/controls/HrnbFormControl';
import HrnbButton from '../components/controls/HrnbButton';
import { SaveIcon } from '../icons';

export default function ResetPasswordPage() {
    const { token } = useParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        if (!token) {
            setError('Недействительная ссылка для сброса пароля');
            return;
        }

        if (!password || password.length < 8) {
            setError('Пароль должен содержать минимум 8 символов');
            return;
        }

        if (password !== confirmPassword) {
            setError('Пароли не совпадают');
            return;
        }

        setLoading(true);
        try {
            const resp = await authApi.resetPassword(token, password, confirmPassword);
            setMessage(resp.message || 'Пароль успешно изменён');
            setTimeout(() => navigate('/login'), 2000);
        } catch (err) {
            setError(err?.response?.data?.message || err?.message || 'Ошибка сброса пароля');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container" style={{ maxWidth: 480, margin: '40px auto' }}>
            <h2>Сброс пароля</h2>
            <HrnbForm onSubmit={handleSubmit}>
                <HrnbFormControl
                    label="Новый пароль"
                    as="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Минимум 8 символов"
                    autoFocus
                />
                <HrnbFormControl
                    label="Подтверждение пароля"
                    as="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Повторите пароль"
                />
                {error && <div style={{ color: 'red', marginTop: 12 }}>{error}</div>}
                {message && <div style={{ color: 'green', marginTop: 12 }}>{message}</div>}
                <HrnbButton
                    type="submit"
                    style={{ width: '100%', marginTop: 20 }}
                    disabled={loading}
                    icon={<SaveIcon />}
                >
                    {loading ? 'Сохранение...' : 'Сменить пароль'}
                </HrnbButton>
            </HrnbForm>
            <div style={{ marginTop: 16, textAlign: 'center' }}>
                <Link to="/login">Вернуться к входу</Link>
            </div>
        </div>
    );
}

